/*
 * 模块名称: 人保公司结算查询页面
 * 创建人: DrugsZ 
 * 创建时间: 2018-01-05 11:39:43 
 * 修改人:   DrugsZ 
 * 最后修改时间: 2018-01-05 11:39:43 
 */

<template>
   <div class="wrapper-content animated fadeInRight tabBox" id="ac-to-rb">
      <div class="ibox-content">
          <account-list @onerror="openModal"></account-list>
      </div>
       <tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModal">
			{{messageStr}}
			<div slot="footer">
		        <button @click="closeModal" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
  </div>
</template>
<script>
    import AccountList from 'components/pages/accountcheck/AccountList'
    import TabModal from 'components/common/TabModal'

    export default{
        name:"PageAccountCheckTORb",
        components:{
            AccountList,
            TabModal
        },
        data(){
            return{
                messageStr:'',
                scrollTop:'0',
            }
        },
        methods:{
            openModal(msg) {
                this.messageStr = msg
            	this.$refs.modalMsg.open();
            	classlist.toggleScroll('close','#ac-to-rb',this);
        	},
        	closeModal(){
        		this.$refs.modalMsg.close();
        		classlist.toggleScroll('open','#ac-to-rb',this);
        	},
        }
    }
</script>


// WEBPACK FOOTER //
// PageAccountCheckToRb.vue?3348f839